import React from 'react'
import { Link, graphql } from 'gatsby'
import Img from 'gatsby-image'
import { GatsbyImage } from 'gatsby-plugin-image'

import Layout from '../components/Layout'
import Seo from '../components/seo'
import marked from 'marked'
import { Container, Row, Col } from 'react-bootstrap'

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.sanityPost
    const siteTitle = this.props.data.site.siteMetadata.title
    const { previous, next } = this.props.pageContext
    const hiddenImage = post.disableImage

    console.log(post.disableImage)
    // let featuredImgFluid = post.frontmatter.featuredImage.childImageSharp.fluid

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <Seo title={post.title} description={post.excerpt} />
        <section id="blog-post" className="blog">
          <div id="news-bg" className="main-heading">
            <Container>
              <Row>
                <Col>
                  <div class="text-center py-5 mt-5">
                    <h1 class="hero-title">{post.title}</h1>
                    <p className="section-p text-white">{post.publishedAt}</p>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-8 mx-auto">
                
                { hiddenImage == true ? ( 
                    null                  
                ): 
                  <GatsbyImage
                      image={
                        post.mainImage ? post.mainImage.asset.gatsbyImageData : ''
                      }
                      imgClassName="img-fluid"
                      className="my-5 mx-auto"
                      alt="Blog Img"
                      placeholder="blurred"
                      layout="constrained"
                      style={{ width: `100%`, margin: `auto` }}
                    />

                } 

            
                
                {/*<small>{post.date}</small>
                <p className="section-p">{post.date}</p>*/}

                <div dangerouslySetInnerHTML={{ __html: marked(post.body) }} />

                <hr />
                <ul
                  style={{
                    display: `flex`,
                    flexWrap: `wrap`,
                    justifyContent: `space-between`,
                    listStyle: `none`,
                    padding: 0,
                  }}
                >
                  <li>
                    {previous ? (
                      <Link
                        className="text-blue"
                        to={`/news/${previous.slug.current}`}
                        rel="prev"
                      >
                        ← {previous.title}
                      </Link>
                    ) : null}
                  </li>
                  <li>
                    {next ? (
                      <Link
                        className="text-blue"
                        to={`/news/${next.slug.current}`}
                        rel="next"
                      >
                        {next.title} →
                      </Link>
                    ) : null}
                  </li>
                </ul>
                <div className="col pt-4 text-center">
                  <Link className="link-btn" to="/news">
                    Take Me Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostTemplateQuery($id: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    sanityPost(id: { eq: $id }) {
      id
      title
      slug {
        current
      }
      body
      publishedAt(formatString: "MMMM DD, YYYY")
      disableImage
      mainImage {
        asset {
          gatsbyImageData(
            layout: CONSTRAINED
            width: 1920
            placeholder: BLURRED
            sizes: "(max-width: 1920px) calc(100vw - 40px), 1920px"
          )
        }
      }
    }
  }
`
